import * as React from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import Heading from "../../Atoms/heading/EventEHRHeading";
import EditProfile from "./EditProfile";
import { useDispatch, useSelector } from "react-redux";
import { patchPatientProfileDetailsData } from "../../../screens/patient-screen/patientSaga";
import { useParams } from "react-router-dom";
import moment from "moment";
import {
  componentKey,
  setCloseEditProfileDialog,
} from "../../../screens/patient-screen/patientSlice";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    BorderAllRounded: "8px",
    Height: "436px",
    width: "708px", // Set your custom width here
    maxWidth: "none", // Prevents Material-UI from overriding your width
  },
}));

interface EventEHREditProfileDialogProps {
  isOpen: boolean;
  patientProfileData: any;
  dialogHeading: string;
  handleClose: () => void;
}

export default function EventEHREditProfileDialog({
  isOpen = false,
  patientProfileData,
  handleClose=()=>{},
  dialogHeading = "Your Heading Here...",
}: EventEHREditProfileDialogProps) {
  const { closeEditProfileDialog } = useSelector(
    (state: any) => state[componentKey]
  );
  const { patientId } = useParams();
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (closeEditProfileDialog) {
      handleClose();
      dispatch(setCloseEditProfileDialog(false));
    }
  }, [closeEditProfileDialog]);

  const onEditProfileDataClick = (data: any) => {
    try {
      const patchPatientProfileDetailsPayload = {
        payload: {
          firstName: data?.patientFirstName,
          lastName: data?.patientLastName,
          email: data?.patientEmail,
          bsaId: data?.patientBSAId,
          dateOfBirth: moment(data?.BirthDate)?.format("YYYY-MM-DD"),
          contactNumber: data?.patientNumber,
          campId: data?.clinicLocation,
        },
        patientId: patientId,
      };
      dispatch(
        patchPatientProfileDetailsData(patchPatientProfileDetailsPayload)
      );
    } catch (error) {
      console.log("error:", error);
    }
  };
  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
      >
        <div
          className="flex justify-between items-center rounded-lg"
          style={{ margin: "14px 24px" }}
        >
          <Heading title={dialogHeading} />
          <div onClick={handleClose} className="cursor-pointer">
            <CloseIcon />
          </div>
        </div>

        <DialogContent
          dividers
          style={{ padding: "16px 24px 24px 24px", borderRadius: "8px" }}
        >
          <EditProfile
            defaultSelectedData={patientProfileData}
            handleOnSubmittedData={(formData) => {
              onEditProfileDataClick(formData);
            }}
            handleClose={handleClose}
          />
        </DialogContent>
      </BootstrapDialog>
    </React.Fragment>
  );
}
